import { createAction, props } from '@ngrx/store';
import { AvailableSchedule, ClassroomCourse, ClassroomCourseFilter } from '../models';
import { Review } from '@shared/models/review';
import { Feedback } from '../models/feedback';
import { Participant } from '../models/participant';

export enum ClassroomCourseActions {
  FetchClassroomCourses = '[Api/ClassroomCourse] Fetch Classroom Courses',
  FetchClassroomCourse = '[Api/ClassroomCourse] Fetch Classroom Course',
  FetchClassroomSchedule = '[Api/ClassroomCourse] Fetch Classroom Schedule',
  FetchInstructorCourses = '[Api/ClassroomCourse] Fetch Instructor Classroom Courses',
  SaveClassroomReview = '[Api/ClassroomCourse] Add Classroom Review.',
  SaveClassroomFeedback = '[Api/ClassroomCourse] Add Classroom Feedback',
  CheckParticipantIdentity = '[Api/ClassroomCourse] Check Participant Identity.',
  DecreaseScheduleCount = '[Api/ClassroomCourse] Decrease Schedule Count.',

  AddClassroomCourses = '[ClassroomCourse] Add Classroom Courses',
  AddClassroomCourse = '[ClassroomCourse] Add Classroom Course',
  AddClassroomSchedule = '[ClassroomCourse] Add Classroom Schedules',
  RemoveClassroomSchedule = '[ClassroomCourse] Remove Classroom Schedules',
  AddInstructorCourses = '[ClassroomCourse] Add Instructor Classroom Courses',
  AddSelectedCourse = '[ClassroomCourse] Add Selected Classroom Course Id',
  RemoveSelectedClassroomCourse = '[ClassroomCourse] Remove Selected Classroom Course Id',
  AddTotalCount = '[ClassroomCourse] Add Digital Course Total Count',
  AddClassroomReview = '[ClassroomCourse] Add Course review',
  AddClassroomFeedback = '[ClassroomCourse] Add Course feedback',
  AddParticipantIdentity = '[ClassroomCourse] Add Participant Identity',
  RemoveParticipantIdentity = '[ClassroomCourse] Remove Participant Identity',
  AddError = '[ClassroomCourse] Add Course Error',
  Empty = '[ClassroomCourse] Empty'
}

// Effects Actions
export const FetchClassroomCourses = createAction(
  ClassroomCourseActions.FetchClassroomCourses,
  props<{ filter?: ClassroomCourseFilter }>()
);
export const FetchClassroomCourse = createAction(
  ClassroomCourseActions.FetchClassroomCourse,
  props<{ courseId: string }>()
);
export const FetchClassroomSchedule = createAction(
  ClassroomCourseActions.FetchClassroomSchedule,
  props<{ courseId: string }>()
);
export const FetchInstructorCourses = createAction(
  ClassroomCourseActions.FetchInstructorCourses,
  props<{ instructorId: string }>()
);
export const SaveClassroomReview = createAction(ClassroomCourseActions.SaveClassroomReview, props<{ courseId: string; review: Review }>());
export const SaveClassroomFeedback = createAction(ClassroomCourseActions.SaveClassroomFeedback, props<{ courseId: string; feedback: Feedback }>());

export const CheckParticipantIdentity = createAction(ClassroomCourseActions.CheckParticipantIdentity, props<{ phone: string }>())
export const DecreaseScheduleCount = createAction(ClassroomCourseActions.DecreaseScheduleCount, props<{ courseId: string, scheduleId: number, numOfBooking: number }>())

// Store Actions
export const AddClassroomCourses = createAction(
  ClassroomCourseActions.AddClassroomCourses,
  props<{ courses: ClassroomCourse[] }>()
);
export const AddClassroomCourse = createAction(
  ClassroomCourseActions.AddClassroomCourse,
  props<{ course: ClassroomCourse }>()
);
export const AddClassroomSchedule = createAction(
  ClassroomCourseActions.AddClassroomSchedule,
  props<{ schedules: AvailableSchedule[] }>()
);
export const RemoveClassroomSchedule = createAction(ClassroomCourseActions.RemoveClassroomSchedule);
export const AddInstructorCourses = createAction(
  ClassroomCourseActions.AddInstructorCourses,
  props<{ instructorCourses: ClassroomCourse[] }>()
);
export const AddSelectedCourse = createAction(
  ClassroomCourseActions.AddSelectedCourse,
  props<{ selectedCourseId: string }>()
);
export const RemoveSelectedClassroomCourse = createAction(ClassroomCourseActions.RemoveSelectedClassroomCourse);

export const AddTotalCount = createAction(ClassroomCourseActions.AddTotalCount, props<{ totalCount: number }>());
export const AddCourseReview = createAction(ClassroomCourseActions.AddClassroomReview, props<{ review: Review }>());
export const AddCourseFeedback = createAction(ClassroomCourseActions.AddClassroomFeedback ,props<{ feedback: Feedback }>());
export const AddParticipantIdentity = createAction(ClassroomCourseActions.AddParticipantIdentity, props<{ participant: Participant}>());
export const RemoveParticipantIdentity = createAction(ClassroomCourseActions.RemoveParticipantIdentity);

export const AddError = createAction(ClassroomCourseActions.AddError, props<{ error: any }>());

export const Empty = createAction(ClassroomCourseActions.Empty);
